module.exports = __webpack_public_path__ + "img/team-member-03.d6f25027.jpg";